
import global from '@/utils/global'
import { defineComponent } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getPlanListData, exportStaffNumListApi, queryStaffNumPageListApi } from '@/api/long-insure-new'
import { queryStaffRecordListApi, getInsureCompanyAxApi, getInsureEnsurePlanApi, getAxServeCompanyIdApi, getServeCompanyIdApi } from '@/api/insure-daily-ax'
import { formatter, downloadBlobFile, downloadFileAndChangeName, downLoadBlob } from '../utils/util'
import dayjs from 'dayjs'

export default defineComponent({
  name: 'InsureDailyCompany',
  components: {},
  data() {
    return {
      planList: [] as any,
      rowId: '', // 当前的 保司id
      rowCode: '', // 当前的 保司编码
      showPeopleInsure: false, // 在保人数抽屉
      showPlanInfo: false, // 方案详情抽屉
      peopleInsureList: [], // 在保人数
      staffRecordPage: 1,
      staffRecordSize: 10,
      peopleFormSearch: {
        searchUserInfo: ''
      },
      staffRecordTotal: 0,
      infoUrl: '',
      insureCompanyId: '',
      reportCaseFileUrl: '',
      commitmentUrl: [],
      planTermsData: {} as any
    }
  },
  created() {
    this.initPlanList()
  },
  watch: {},
  methods: {
    async initPlanList() {
      console.log(this.formSearch)
      const result = await getInsureCompanyAxApi({
        platformCode: 1, // 平台来源（1:PC B端  2:微信B端）
        insureType: this.$route.query.insureType // 保险产品（1:日结保  2:长期保  3:团意险保  8:安心日保）
      })
      this.planList = result
    },
    async toDetail(item) {
      console.log(item, 'itemitemitemitem')

      // 获取方案详情
      this.infoUrl = item.introduceUrl
      this.insureCompanyId = item.id
      this.reportCaseFileUrl = item.reportCaseFileUrl
      this.commitmentUrl = item.commitmentUrl

      await this.onGetPlanListData()
      // 获取方案条款
      this.showPlanInfo = true
    },

    // 获取方案条款信息
    async onGetPlanListData() {
      const data = await getPlanListData({
        insureCompanyId: this.insureCompanyId
      })
      console.log(data, '查询方案条款')
      this.planTermsData = data
    },
    // 当前在保人数 弹框
    async onLinkWorkers(row) {
      console.log(row, '1111')

      this.showPeopleInsure = true
      this.rowId = row.id
      this.rowCode = row.code
      this.initPeopleInsureList()
    },

    // 根据派遣单位code导出在保人员
    async onDetailExport() {
      // 安心日保
      if (this.$route.query.insureType == 2) {
        const res = await getServeCompanyIdApi(this.rowCode, 'plan')
        downloadBlobFile(res)
      }
      // 安心日保
      if (this.$route.query.insureType == 8) {
        const res = await getAxServeCompanyIdApi(this.rowCode, 'plan')
        downloadBlobFile(res)
      }
    },

    async handleDownload(Urls: any, name: string) {
      // 承诺函 可能是多张
      if (Array.isArray(Urls) && name == '承诺函') {
        if (Urls.length > 0) {
          try {
            for (let i = 0; i < Urls.length; i++) {
              let sr = Urls[i].lastIndexOf('.')
              let fileType = Urls[i].substr(sr + 1)
              const url = Urls[i]
              const response = await fetch(url)
              const blob = await response.blob()
              const blobUrl = window.URL.createObjectURL(blob)

              const link = document.createElement('a')
              link.href = blobUrl
              link.download = `承诺函_${i + 1}.${fileType}` // 或从URL提取文件名
              document.body.appendChild(link)
              link.click()

              // 清理
              setTimeout(() => {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(blobUrl)
              }, 100)

              // 添加延迟避免浏览器阻止
              if (i < Urls.length - 1) {
                await new Promise((resolve) => setTimeout(resolve, 500))
              }
            }
          } catch (error) {
            console.error('下载失败:', error)
          }
        }
      } else {
        let sr = Urls.lastIndexOf('.')
        let fileType = Urls.substr(sr + 1)
        if (fileType == 'jpg' || fileType == 'png' || fileType == 'jpeg') {
          fetch(Urls)
            .then((res) => {
              return res.blob()
            })
            .then((blob: Blob) => {
              const a = document.createElement('a')
              const objUrl = window.URL.createObjectURL(blob)
              a.href = objUrl
              a.download = name
              document.body.appendChild(a)
              a.click()
              window.URL.revokeObjectURL(objUrl)
              document.body.removeChild(a)
            })
        } else {
          console.log('非图片下载')
          //

          downloadFileAndChangeName(Urls, name + '.' + fileType)
        }
      }
    },
    onDownLoadCommitment() {
      if (this.commitmentUrl.length < 1) {
        return
      }
      this.handleDownload(this.commitmentUrl, '承诺函')
    },
    onDownLoadReportCase() {
      if (!this.reportCaseFileUrl) {
        return
      }
      this.handleDownload(this.reportCaseFileUrl, '理赔材料')
    },
    goBack() {
      this.infoUrl = ''
      this.insureCompanyId = ''
      this.reportCaseFileUrl = ''
      this.commitmentUrl = []
      this.showPeopleInsure = false
      this.showPlanInfo = false
    },

    // 在保人数查询
    onPeopleInsureSearch() {
      this.initPeopleInsureList()
    },
    onPeopleInsureReset() {
      this.peopleFormSearch = {
        searchUserInfo: ''
      }
      this.onPeopleInsureSearch()
    },
    peopleInsureSizeChange() {
      this.staffRecordPage = 1
      this.initPeopleInsureList()
    },
    handleStaffRecordSizeChange() {
      this.staffRecordPage = 1
      this.initPeopleInsureList()
    },
    // 安心日保 当前 方案id 投保人员-分页查询
    async initPeopleInsureList() {
      if (this.$route.query.insureType == 2) {
        const result = await queryStaffNumPageListApi({
          pageSize: this.staffRecordSize,
          pageNum: this.staffRecordPage,
          insureCompany: this.rowCode,
          searchUserInfo: this.peopleFormSearch.searchUserInfo,
          policyStatus: 1
        })
        this.staffRecordTotal = result.totalCount
        this.peopleInsureList = result.list
      }
      // 安心日保
      if (this.$route.query.insureType == 8) {
        const result = await queryStaffRecordListApi({
          pageSize: this.staffRecordSize,
          pageNum: this.staffRecordPage,
          insureCompany: this.rowCode,
          searchUserInfo: this.peopleFormSearch.searchUserInfo,
          policyStatus: 1
        })
        this.staffRecordTotal = result.totalCount
        this.peopleInsureList = result.list
      }
    },
    // 检查在保结束时间，如果是2099-01-01则显示"结案断保"
    checkInsureEndTime(insureEndTime: string) {
      if (!insureEndTime) return '长期有效'
      // 使用 dayjs 判断日期是否为 2099-01-01
      const endDate = dayjs(insureEndTime).format('YYYY-MM-DD')
      return endDate === '2099-01-01' ? '结案断保' : insureEndTime
    }
  }
})
